import React, {useEffect} from 'react';

// services
import {ConfigManager} from '../../services/ConfigManager';

// components
import Menu from '../Menu';

// hooks
import {useMenuItems} from '../../hooks';

// styles
import {
  MobileSideBarContainer,
  MobileTopSection,
  CloseButton,
  CloseIcon,
  MobileMenuContent,
  MobileTopMenuSection,
  MobileBottomMenuSection,
  LenderInformation,
} from './MobileSideBar-styles';
import {LenderName, Logo, Divider} from '../SideBar/SideBar-styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const MobileSideBar = ({isOpen, onClose}: Props) => {
  const {menuItems, configMenuItems} = useMenuItems();
  const portalConfig = ConfigManager.getConfig();

  useEffect(() => {
    // Handle ESC key press (accessibility feature)
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    const handlePopstate = () => {
      // Close the sidebar when the user navigates back or forward
      if (isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      window.addEventListener('popstate', handlePopstate);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      window.removeEventListener('popstate', handlePopstate);
      // Restore body scrolling when sidebar is closed
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  return (
    <MobileSideBarContainer
      isOpen={isOpen}
      aria-hidden={!isOpen}
      role="dialog"
      aria-modal="true">
      <MobileTopSection>
        <LenderInformation>
          {portalConfig?.logo && <Logo url={portalConfig.logo}></Logo>}
          <LenderName>{portalConfig?.lenderName}</LenderName>
        </LenderInformation>
        <CloseButton
          onClick={onClose}
          aria-label="Close menu"
          title="Close menu">
          <CloseIcon />
        </CloseButton>
      </MobileTopSection>
      <Divider />
      <MobileMenuContent>
        <MobileTopMenuSection>
          <Menu menuItems={menuItems} closeMenu={onClose} />
        </MobileTopMenuSection>
        <MobileBottomMenuSection>
          <Divider />
          <Menu menuItems={configMenuItems} closeMenu={onClose} />
        </MobileBottomMenuSection>
      </MobileMenuContent>
    </MobileSideBarContainer>
  );
};

export default MobileSideBar;
